/* src/app/core/components/background/background.component.scss */
@-webkit-keyframes bg-scrolling-reverse {
  0% {
    background-position: 495px 0px;
  }
}
@-moz-keyframes bg-scrolling-reverse {
  0% {
    background-position: 495px 0px;
  }
}
@-o-keyframes bg-scrolling-reverse {
  0% {
    background-position: 495px 0px;
  }
}
@keyframes bg-scrolling-reverse {
  0% {
    background-position: 495px 0px;
  }
}
@-webkit-keyframes bg-scrolling {
  100% {
    background-position: 495px 0px;
  }
}
@-moz-keyframes bg-scrolling {
  100% {
    background-position: 495px 0px;
  }
}
@-o-keyframes bg-scrolling {
  100% {
    background-position: 495px 0px;
  }
}
@keyframes bg-scrolling {
  100% {
    background-position: 495px 0px;
  }
}
.background {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}
@media (min-width: 768px) {
  .background {
    max-width: 414px;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
  }
}
.background .frame-img {
  position: relative;
}
.background .frame {
  position: relative;
  top: 150px;
  margin-top: var(--ion-safe-area-top);
  max-width: 320px;
  height: 60vh;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50px;
  border: 6px solid black;
  -webkit-animation: bg-scrolling-reverse 10s infinite;
  -moz-animation: bg-scrolling-reverse 10s infinite;
  -o-animation: bg-scrolling-reverse 10s infinite;
  animation: bg-scrolling-reverse 10s infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-timing-function: linear;
  -o-animation-timing-function: linear;
  animation-timing-function: linear;
}
@media (min-height: 940px) {
  .background .frame {
    max-height: 550px;
  }
}
.background .frame .lights {
  border-radius: 50px;
}
.background .frame img {
  min-width: 320px;
  max-height: 550px;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.lights {
  border: none !important;
  position: absolute;
  left: 0;
  z-index: 0 !important;
}
.koffer {
  border: none !important;
  min-width: unset !important;
  max-height: unset !important;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 300px !important;
  height: 175px !important;
  bottom: -15vh;
  z-index: 100 !important;
  object-fit: contain !important;
}
.koffer:hover {
  cursor: pointer;
}
.missions {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
@media (min-width: 321px) {
  .missions {
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.buttons {
  display: flex;
  position: absolute;
  flex-direction: column;
  left: 25px;
  bottom: 100px;
  z-index: 1000;
}
.buttons .blue {
  background: #4ac8f3;
}
.buttons button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  color: #fff;
  border-radius: 100px;
  font-size: 14px;
  margin: 5px 0;
  background: #b5b5b5;
}
.buttons button img {
  width: 24px;
  height: 24px;
  margin-left: 5px;
}
.koffer-missions {
  background: #fff;
  top: 25px;
  width: 115%;
  max-width: 340px;
  z-index: 101;
  padding: 15px;
  border-radius: 10px;
  max-height: 400px;
  overflow-y: auto;
}
.pointer {
  position: absolute;
  top: 57%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.pointer img {
  transition: all 2s;
  transform: rotate(0deg);
  transform-origin: bottom;
  border: none !important;
  min-width: unset !important;
  max-height: unset !important;
}
.amount-finished-missions {
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
}
.count-text {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  width: fit-content;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.count {
  mask-image: url("./media/levels.svg");
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  mask-size: contain;
}
.levels-outline {
  min-width: unset !important;
  max-height: unset !important;
  position: absolute;
  height: 122px !important;
  z-index: 100 !important;
  object-fit: contain !important;
}
.chart {
  margin: 0 auto;
  padding: 0;
  list-style-type: none;
}
.chart *,
.chart::before {
  box-sizing: border-box;
}
.chart {
  position: relative;
  width: 300px;
  height: 150px;
  overflow: hidden;
}
.chart::before,
.chart::after {
  position: absolute;
}
.chart::before {
  content: "";
  width: inherit;
  height: inherit;
  border: 45px solid transparent;
  border-bottom: none;
  border-top-left-radius: 175px;
  border-top-right-radius: 175px;
}
.chart div {
  position: absolute;
  top: 100%;
  left: 0;
  width: inherit;
  height: inherit;
  border: 45px solid #aeaeae;
  border-top: none;
  border-bottom-left-radius: 175px;
  border-bottom-right-radius: 175px;
  transform-origin: 50% 0;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  animation-fill-mode: forwards;
  animation-duration: 0.4s;
  animation-timing-function: linear;
}
.chart div:nth-child(1) {
  z-index: 4;
  border-color: #4ac8f3;
  transition: all 2s;
}
.chart span {
  position: absolute;
  font-size: 18px;
  backface-visibility: hidden;
  color: white;
  animation: fade-in 0.4s linear forwards;
}
.chart .candidate-one-percentage {
  top: 10px;
  left: -35px;
  transform: rotate(-90deg);
}
.chart .candidate-two-percentage {
  top: -35px;
  left: -35px;
  transform: rotate(-90deg);
}
.profile {
  display: flex;
  align-items: center;
  flex-direction: row;
  min-width: 48px;
}
.double-arrow-down {
  position: absolute;
  bottom: 5vh;
  z-index: 100;
}
.open-koffer-button {
  position: absolute;
  bottom: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.main-button {
  padding: 15px 25px;
  color: #fff;
  border-radius: 100px;
  font-size: 14px;
  margin: 5px 0;
  background: #4ac8f3;
  z-index: 100;
}
/*# sourceMappingURL=background.component.css.map */
